import React from "react";
import { Outlet } from "react-router-dom";
const WarrantyIndex = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default WarrantyIndex;
